export default "/Resources/62262da9cda6e0ffc43ec20cd2a0107e.svg";